import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { Menu, MenuItem, IconButton, Divider, Avatar, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface UserMenuProps {
	title: string;
}

export const UserMenu = ({ title }: UserMenuProps) => {
	const navigate = useNavigate();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleEditUser = () => {
		handleClose();
		navigate('/edit-user');
	};

	const handleChangePassword = () => {
		handleClose();
		navigate('/change-password');
	};

	return (
		<>
			<IconButton
				onClick={handleClick}
				size="large"
				aria-label="account of current user"
				aria-controls={open ? 'account-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
			>
				<AccountBoxIcon fontSize="large" sx={{ color: 'black' }} />
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			>
				<MenuItem 
					sx={{ 
						opacity: 1,
						'&.Mui-disabled': {
							opacity: 1,
							color: 'inherit'
						},
						gap: 1,
					}}
					disabled
				>
					<ListItemIcon>
						<Avatar sx={{ width: 32, height: 32 }} />
					</ListItemIcon>
					<ListItemText primary={title} />
				</MenuItem>
				<Divider />
				<MenuItem onClick={handleEditUser}>
					Editar usuario
				</MenuItem>
				<MenuItem onClick={handleChangePassword}>
					Cambiar contraseña
				</MenuItem>
			</Menu>
		</>
	);
}; 